/* eslint-disable quotes */
const config = {
  title: '面試系統',
  lable_username: '帳號名稱',
  lable_psd: '密碼',
  lable_remeb_Me: '記住我',
  forgot_psd: '忘記密碼',
  login_btn: '登入',
  logSuccess: '登錄系統成功！',
  logError: {
    200: '密碼不正確\n或\n此帳號不存在，請重新輸入！',
    201: '這個帳戶被鎖定,請與系統管理員聯絡',
    0: '對不起! 目前系统繁忙\n請稍後再試',
    104: '連接超時',
  },
  select_school: '請選擇學校',
  school_name: '學校名稱',
  next_step: '下一步',
  Traditional: '繁體中文',
  Simplified: '簡體中文'
};

export default config;
